/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ProgramType, ProgramTypeFromJSON, ProgramTypeToJSON } from './'

/**
 *
 * @export
 * @interface EnrollmentDashboard
 */
export interface EnrollmentDashboard {
  /**
   * Unique identifier for the community that holds the program the student is enrolled in.
   * @type {number}
   * @memberof EnrollmentDashboard
   */
  communityKey: number
  /**
   * Name of the community that holds the program the student is enrolled in.
   * @type {string}
   * @memberof EnrollmentDashboard
   */
  communityName: string
  /**
   * Unique identifier for the program the student is enrolled in.
   * @type {number}
   * @memberof EnrollmentDashboard
   */
  programKey: number
  /**
   *
   * @type {ProgramType}
   * @memberof EnrollmentDashboard
   */
  programType: ProgramType
  /**
   * Year in which the enrollment was created
   * @type {number}
   * @memberof EnrollmentDashboard
   */
  year: number
  /**
   * Total ENROLLED and PENDING enrollments
   * @type {number}
   * @memberof EnrollmentDashboard
   */
  total: number
}

export function EnrollmentDashboardFromJSON(json: any): EnrollmentDashboard {
  return EnrollmentDashboardFromJSONTyped(json, false)
}

export function EnrollmentDashboardFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EnrollmentDashboard {
  if (json === undefined || json === null) {
    return json
  }
  return {
    communityKey: json['communityKey'],
    communityName: json['communityName'],
    programKey: json['programKey'],
    programType: ProgramTypeFromJSON(json['programType']),
    year: json['year'],
    total: json['total'],
  }
}

export function EnrollmentDashboardToJSON(
  value?: EnrollmentDashboard | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    communityKey: value.communityKey,
    communityName: value.communityName,
    programKey: value.programKey,
    programType: ProgramTypeToJSON(value.programType),
    year: value.year,
    total: value.total,
  }
}
